import { InitAdapter, SubmitAdapter } from '../../types';
import { initPapiEditorText } from '../../utils/editor';

export const initAdapter: InitAdapter = ({
  description = initPapiEditorText(),
  deviation,
}) => {
  const descriptionHtml = deviation?.extended?.descriptionText?.html;
  const isLegacyDescription =
    descriptionHtml?.type === 'writer' && descriptionHtml.markup;
  return isLegacyDescription ? undefined : description;
};

export const submitAdapter: SubmitAdapter = ({ descriptionState }) => {
  return {
    descriptionState:
      typeof descriptionState === 'function'
        ? descriptionState()
        : descriptionState || undefined,
  };
};
